import React, {
    useContext, useState
} from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import moment from 'moment';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import cx from 'classnames';
import messages from '../../MLSummary.messages'

import styles from '../../MLSummary.module.scss'
import { IconButton } from '@jutro/legacy/components';

function MLDrivers({ data, driverDetailsOpen, show }) {
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const [didUpdate, setDidUpdate] = useState(false);
    const {
        getOccupationTypeName
    } = MLDriverVehicleUtil();


    if (_.isEmpty(data)) {
        return null;
    }

    const toggleDriverDetails = (driver) => {
        driverDetailsOpen[driver.publicID_ML] = !driverDetailsOpen[driver.publicID_ML];
        setDidUpdate(!didUpdate);
    };

    const getTypeListDisplayName = (typelist, value) => {
        if (!value) {
            return undefined;
        }
        const typeCodeName = viewModelService.productMetadata.get('pc').types.getTypelist(typelist).getCode(value).name;
        return translator({
            id: typeCodeName,
            defaultMessage: typeCodeName
        });
    };

    const getLicenseStateDisplay = (licenseState) => {
        if (licenseState === 'ca_ml' || licenseState === 'ust_ml' || licenseState === 'fl_ml') {
            return getTypeListDisplayName('Jurisdiction', licenseState);
        }
        return licenseState;
    };

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th />
                    <th>{translator(messages.Name)}</th>
                    <th>{translator(messages.DOB)}</th>
                    <th>{translator(messages.Gender)}</th>
                    <th>{translator(messages.MaritalStatus)}</th>
                    <th>{translator(messages.License)}</th>
                </tr>
            </thead>
        );
    }

    const formatDOB = (dateOfBirth) => {
        const date = MLLocalDateUtil.localDate2Date(dateOfBirth);
        return moment(date).format('MM/DD/YYYY');
    }

    const generateDriverDetails = (driver) => {
        if (driverDetailsOpen[driver.publicID_ML]) {
            return (
                <tr>
                    <td />
                    <td colSpan="5">
                        <div className="row">
                            <div className="col-md-3">
                                <p><strong>{translator(messages.RelationshiptoPrimaryInsured)}</strong></p>
                                <p>{driver.relationshipToInsured_ML}</p>
                            </div>
                            <div className="col-md-3">
                                <p><strong>{translator(messages.AgeFirstLicensed)}</strong></p>
                                <p>{driver.ageFirstLicensed_ML}</p>
                            </div>
                            <div className="col-md-3">
                                <p><strong>{translator(messages.Occupation)}</strong></p>
                                <p>{ getOccupationTypeName(driver.occupation_Ext) }</p>
                            </div>
                            {(driver.isGoodStudent_ML === true)? 
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.GoodStudent)}</strong></p>
                                    <p>{translator(messages.Yes)}</p>
                                </div> :
                                <></>
                            }
                            {(driver.residentStudentSchoolName_ML !== undefined)? 
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.ResidentStudent)}</strong></p>
                                    <p>{translator(messages.Yes)}</p>
                                </div> :
                                <></>
                            }
                            {(driver.residentStudentSchoolName_ML !== undefined)? 
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.NameofSchool)}</strong></p>
                                    <p>{driver.residentStudentSchoolName_ML}</p>
                                </div> : 
                                <></>
                            }
                            {(driver.cFREffDate_ML !== undefined)? 
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.RequireProofofFinancialResponsibility)}</strong></p>
                                    <p>{translator(messages.Yes)}</p>
                                </div> : 
                                <></>
                            }
                            {(driver.cFREffDate_ML !== undefined)? 
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.CertificateEffectiveDate)}</strong></p>
                                    <p>{MLLocalDateUtil.toLocalDate(driver.cFREffDate_ML)}</p>
                                </div> : 
                                <></>
                            }
                            {(driver.caseNumber_ML !== undefined)? 
                                <div className="col-md-3">
                                    <p><strong>{translator(messages.CaseNumber)}</strong></p>
                                    <p>{driver.caseNumber_ML}</p>
                                </div> :
                                <></>
                            }
                        </div>
                    </td>
                </tr>

            );
        }
        return ( <></> );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.Drivers)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.filter((it) => it.driverType_ML === "rated").map((driver) => {
                            const iconStyle = driverDetailsOpen[driver.publicID_ML]? cx(styles.iconBlue, 'icon-accordion-down', 'icon-rotate-180') : cx(styles.iconBlue, 'icon-accordion-down')
                            return (
                                <>
                                    <tr>
                                        <td className="table-data-collapse">
                                            <h2 className="subsection-header">
                                                <IconButton
                                                    onClick={() => toggleDriverDetails(driver)}
                                                    role="menuitem"
                                                    icon="icon-accordion-down"
                                                    className={iconStyle}
                                                />
                                            </h2>
                                        </td>
                                        <td><strong>{driver.displayName}</strong></td>
                                        <td>{formatDOB(driver.dateOfBirth)}</td>
                                        <td>{driver.gender_ML}</td>
                                        <td>{driver.maritalStatus_ML}</td>
                                        <td>{driver.licenseNumber} {(driver.licenseState) ? <span>({getLicenseStateDisplay(driver.licenseState)})</span> : <></>}</td>
                                    </tr>
                                    <tr />
                                    {generateDriverDetails(driver)}
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLDrivers.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    driverDetailsOpen: PropTypes.arrayOf(PropTypes.shape({})),
    show: PropTypes.bool
};
MLDrivers.defaultProps = {
    data: [],
    driverDetailsOpen: [],
    show: false
};
export default MLDrivers;
